import React from 'react';
import { useNavigate } from 'react-router-dom';
import Separator from '../../../../../../components/Common/UI/Separator';
import { Button } from '../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../components/Common/Icons/Icons';
import { AccountManagementRes } from '../../columns';
import { CreateAccountTypeEnum } from '../Form';
import { useAccountManagementProvider } from '../../../../../context/accountManagement';

interface IAccountManagementPrevAccount {
  handleBack: () => void;
  state: AccountManagementRes;
}

function AccountManagementPrevAccount({ handleBack, state }: IAccountManagementPrevAccount) {
  const { handleShowTable } = useAccountManagementProvider();
  const navigate = useNavigate();

  const handleConfirm = () => {
    handleShowTable(true);
    navigate('/infoTrac/account-management/', { replace: true });
  };

  return (
    <>
      <div className="grid grid-cols-[160px,auto] gap-[15px]">
        <div>Account Number:</div>
        <div className="opacity-60">{state.accountNumber}</div>
      </div>
      <div className="grid grid-cols-[160px,auto] gap-[15px]">
        <div>Account Type:</div>
        <div className="opacity-60">
          {CreateAccountTypeEnum[state.accountType as keyof typeof CreateAccountTypeEnum]}
        </div>
      </div>
      <div className="grid grid-cols-[160px,auto] gap-[15px]">
        <div>Account Name:</div>
        <div className="opacity-60">{state.accountName}</div>
      </div>
      <Separator className="mt-[20px]" />
      <div className="flex justify-between items-center gap-[20px] pt-[10px]">
        <Button variant="link" onClick={handleBack} className="flex gap-[10px] items-center px-0">
          <Icons.ArrowRight className="rotate-180" />
          Change
        </Button>
        <Button onClick={handleConfirm} className="flex gap-[10px] items-center">
          <Icons.SaveFilled className="opacity-60 w-[20px] h-[20px]" />
          Confirm
        </Button>
      </div>
    </>
  );
}

export default AccountManagementPrevAccount;
